// tslint:disable: max-line-length
import React from 'react';
import { getItem, removeItem, setItem } from '../../../utils/localStorage';
import LoadingContent from 'lqa-ui/lib/Components/LoadingContent';
import { showErrorMessage } from '../../../helpers/showMessage';
import { getTemplateData } from '../../../requests/login';
import { uniq } from 'lodash';
import { BottomSheet } from '../../../app/common/sharedComponents/BottomSheet';
import { ButtonBlockColumn } from './../../../app/common/sharedStyledComponents/GenericStyles.styled';
import { ButtonLarge } from './../../../app/common/sharedComponents/buttons/ButtonLarge';

export const pressAndHoldMenu = (
  pressHoldData,
  setOpenPressHold,
  openPressAndHold,
  selectedAssessment,
  tempData,
  apiData,
  navigate,
  showSelfAssessment = true,
  selfStayStart?: string,
  assessmentId?: number
) => {
  const userData = getItem('user');
  const alreadyAssignedUsers = [userData.user.id];
  if (!pressHoldData) {
    return;
  }
  if (!apiData) {
    return <LoadingContent />;
  }
  const getSelectedCategories = (catData) => {
    const selfAssessmentSelectedCategory: any[] = [];
    selfAssessmentSelectedCategory.push(catData.sourceTemplateCategoryId);
    let parentCat: any = {};
    let parentId = catData.parentId;
    do {
      // tslint:disable-next-line:triple-equals
      parentCat = apiData.data.find((apData) => apData.id == parentId);
      if (parentCat) {
        parentId = parentCat.parentId;
        selfAssessmentSelectedCategory.push(parentCat.sourceTemplateCategoryId);
      } else if (parentId && !parentCat) {
        selfAssessmentSelectedCategory.push(parentId);
      }
    } while (parentCat && !!parentCat.parentId);

    let newCat: any = [];
    if (!parentId) {
      newCat = apiData.data.find((d) =>
        d.subCategory.find(
          (o) => o.sourceTemplateCategoryId === catData.sourceTemplateCategoryId
        )
      );
      if (newCat) {
        if (newCat.parentId) {
          selfAssessmentSelectedCategory.push(newCat.parentId);
        }
        if (newCat.sourceTemplateCategoryId) {
          selfAssessmentSelectedCategory.push(newCat.sourceTemplateCategoryId);
        }
      }
    }

    return selfAssessmentSelectedCategory;
  };
  const selectedCategories = uniq(getSelectedCategories(pressHoldData));
  const isDepartmentAvailable = async (selectedDepartment) => {
    const defaultTemplateId = getItem('defaultTemplateId');
    const templateData: any = await getTemplateData(
      defaultTemplateId,
      userData
    );
    if (
      templateData &&
      templateData.category.length &&
      templateData.category.filter((k) =>
        selectedDepartment.includes(k.sourceTemplateCategoryId)
      ) &&
      templateData.category.filter((k) =>
        selectedDepartment.includes(k.sourceTemplateCategoryId)
      ).length !== selectedDepartment.length
    ) {
      showErrorMessage(
        'This department is not included in your current template'
      );
      setOpenPressHold(false);
      return true;
    } else {
      return false;
    }
  };
  return (
    // <Portal>
    <BottomSheet
      key={'test'}
      isOpen={openPressAndHold}
      onClose={() => setOpenPressHold(false)}
    >
      {/* <Content> */}
      <div className="text-center p-20">
        <ButtonBlockColumn>
          <ButtonLarge
            title="Create Action Plan"
            onClick={async () => {
              if (await isDepartmentAvailable(selectedCategories)) {
                return;
              }
              navigate('/createActionPlan', {
                state: {
                  sourceTemplateCategoryId:
                    pressHoldData.sourceTemplateCategoryId,
                  visit: pressHoldData.visit,
                  selectedAssessment,
                  selectedStandards: pressHoldData.standard,
                  alreadyAssignedUsers,
                  imageAttachments: pressHoldData.imageAttachments,
                  selfAssessmentId: assessmentId,
                  selfStayStart,
                },
              });
            }}
            backgroundColor="oxfordBlue"
          />
          {showSelfAssessment && (
            <ButtonLarge
              title="Create Self Assessment"
              onClick={ () => {
                const saTemplateId =
                  tempData.length > 0 && tempData[0].templateId;
                const subDepartmentName = pressHoldData.name;
                setItem('saTemplateId', saTemplateId);
                removeItem('parentAssessment');
                removeItem('selfAssessments');
                removeItem('disabledCategories');
                navigate('/selfAssessment/selectDepartments', {
                  state: { subDepartmentName, templateId: saTemplateId },
                });
              }}
              outlined={true}
              inverted={true}
            />
          )}
        </ButtonBlockColumn>
      </div>
    </BottomSheet>
  );
};
